<template>image with link</template>
